import React from 'react';
import Highcharts from 'highcharts/highstock';
import HighchartsReact from 'highcharts-react-official';

import data_dnf from './data_dnf';
import pred_dnf_v1 from './pred_dnf_v1';
import pred_dnf_v2 from './pred_dnf_v2';
import pred_dnf_v3 from './pred_dnf_v3';

import data_c from './data_c';
import pred_c_v1 from './pred_c_v1';
import pred_c_v2 from './pred_c_v2';
import pred_c_v3 from './pred_c_v3';

const base = {
  colors: ['#7cb5ec', '#ff4500', '#228b22', '#434348'],
  credits: {
    enabled: false
  },
  scrollbar: {
    enabled: false
  },
  legend: {
    enabled: true
  },
  rangeSelector: {
    buttons: [{
      type: 'millisecond',
      count: 100,
      text: '100'
    }, {
      type: 'millisecond',
      count: 300,
      text: '300'
    }, {
      type: 'millisecond',
      count: 500,
      text: '500'
    }, {
      type: 'millisecond',
      count: 1000,
      text: '1k'
    }, {
      type: 'millisecond',
      count: 2000,
      text: '2k'
    }],
    inputEnabled: false
  }
}

const options1 = {
  ...base,
  title: {
    text: 'Degrade-and-Fire Model',
    margin: 1,
    style: { fontSize: '16px' }
  },
  plotOptions: {
    series: {
      enableMouseTracking: false,
      lineWidth: 1.2
    }
  },
  xAxis: {
    min: 400,
    max: 1400
  },
  yAxis: {
    title: { enabled: false },
    min: -20,
    max: 220,
    tickInterval: 20,
  },
  series: [
    {
      name: 'Training Data',
      data: data_dnf.slice(0, 6500)
    },
    {
      name: 'Prediction #1',
      data: pred_dnf_v1.slice(0, 6000)
    },
    {
      name: 'Prediction #2',
      data: pred_dnf_v2.slice(0, 6000)
    },
    {
      name: 'Prediction #3',
      data: pred_dnf_v3.slice(0, 1200)
    },
  ]
};

const options2 = {
  ...base,
  title: {
    text: 'Chaotic Insulin-Glucose Model',
    margin: 1,
    style: { fontSize: '16px' },
  },
  plotOptions: {
    series: {
      enableMouseTracking: false,
      lineWidth: 1.2
    }
  },
  xAxis: {
    min: 1600,
    max: 2600
  },
  yAxis: {
    title: { enabled: false },
    min: 9000,
    max: 14000,
    tickInterval: 1000,
  },
  series: [
    {
      name: 'Training Data',
      data: data_c
    },
    {
      name: 'Prediction #1',
      data: pred_c_v1
    },
    {
      name: 'Prediction #2',
      data: pred_c_v2
    },
    {
      name: 'Prediction #3',
      data: pred_c_v3
    },
  ]
};

const opts = { style: { height: '400px', width:'100%' }};

function Results() {
  return (
    <div className="d-flex flex-wrap">
      <HighchartsReact
        highcharts={Highcharts}
        constructorType={'stockChart'}
        options={options1}
        containerProps={opts}
      />
      <HighchartsReact
        highcharts={Highcharts}
        constructorType={'stockChart'}
        options={options2}
        containerProps={opts}
      />
    </div>
  );
}

export default Results;
